// Display form rules.

export const showAddPageForm = (uid, projectOwer, projectUsers, team) => {
  if (!uid) return false;

  if (
    uid === projectOwer || // Project owner can add.
    projectUsers.some((u) => u.uid === uid && u.access === 'edit') || // Project member with `edit` access can add.
    (team && // Team member with `edit` access can add.
      team.isDisabled === false &&
      team.users.some((u) => u.uid === projectOwer) &&
      projectUsers.some((u) => u.uid === uid && u.access === 'edit'))
  )
    return true;

  return false;
};

// Upgrade message rules.

export const canAddNewPage = (projectOwer, projectUsers, pagesLength) => {
  const ownerDetails = projectUsers.find((u) => u.uid === projectOwer);

  if (!ownerDetails) return false;

  if (
    ownerDetails.projectPagesCount === -1 ||
    pagesLength < (ownerDetails.projectPagesCount || 5)
  )
    return true;

  return false;
};
